/**
 * @flow
 * @relayHash 05924206b30b37172effab673ae9edc3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchResultsQueryVariables = {|
  after?: ?string,
  authors?: ?$ReadOnlyArray<?number>,
  before?: ?string,
  categories?: ?$ReadOnlyArray<?number>,
  first?: ?number,
  last?: ?number,
  q?: ?string,
  references?: ?$ReadOnlyArray<?number>,
  sort?: ?string,
  titleOnly?: ?boolean,
|};
export type SearchResultsQueryResponse = {|
  +search: ?{|
    +searchResults: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +pk: ?number,
          +name: string,
          +preview: ?string,
          +hasAttachments: ?boolean,
          +bloc: {|
            +name: string
          |},
          +isHomeBloc: ?boolean,
          +category: {|
            +name: string
          |},
          +effectiveDate: ?string,
          +legacyEffectiveDate: ?string,
          +revisionDate: ?string,
          +approvalDate: ?string,
          +restricted: boolean,
        |}
      |}>,
    |},
    +guestAccessToken: ?string,
  |}
|};
export type SearchResultsQuery = {|
  variables: SearchResultsQueryVariables,
  response: SearchResultsQueryResponse,
|};
*/


/*
query SearchResultsQuery(
  $after: String
  $authors: [Int]
  $before: String
  $categories: [Int]
  $first: Int
  $last: Int
  $q: String
  $references: [Int]
  $sort: String
  $titleOnly: Boolean
) {
  search(authors: $authors, categories: $categories, q: $q, references: $references, sort: $sort, titleOnly: $titleOnly) {
    searchResults(after: $after, before: $before, first: $first, last: $last) {
      totalCount
      edges {
        node {
          id
          pk
          name
          preview
          hasAttachments
          bloc {
            name
            id
          }
          isHomeBloc
          category {
            name
            id
          }
          effectiveDate
          legacyEffectiveDate
          revisionDate
          approvalDate
          restricted
        }
      }
    }
    guestAccessToken
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "authors",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "before",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "categories",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "last",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "q",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "references",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "titleOnly",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "authors",
    "variableName": "authors",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "categories",
    "variableName": "categories",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "q",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "references",
    "variableName": "references",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "titleOnly",
    "variableName": "titleOnly",
    "type": "Boolean"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last",
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "preview",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasAttachments",
  "args": null,
  "storageKey": null
},
v9 = [
  v6
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isHomeBloc",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionDate",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "guestAccessToken",
  "args": null,
  "storageKey": null
},
v17 = [
  v6,
  v4
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchResultsQuery",
  "id": "689d7be987aa4b061bf0d6de421aa5ea",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchResultsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "search",
        "storageKey": null,
        "args": v1,
        "concreteType": "SearchType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchResults",
            "storageKey": null,
            "args": v2,
            "concreteType": "SearchCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v6,
                      v7,
                      v8,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v9
                      },
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryType",
                        "plural": false,
                        "selections": v9
                      },
                      v11,
                      v12,
                      v13,
                      v14,
                      v15
                    ]
                  }
                ]
              }
            ]
          },
          v16
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchResultsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "search",
        "storageKey": null,
        "args": v1,
        "concreteType": "SearchType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchResults",
            "storageKey": null,
            "args": v2,
            "concreteType": "SearchCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v6,
                      v7,
                      v8,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v17
                      },
                      v10,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryType",
                        "plural": false,
                        "selections": v17
                      },
                      v11,
                      v12,
                      v13,
                      v14,
                      v15
                    ]
                  }
                ]
              }
            ]
          },
          v16
        ]
      }
    ]
  }
};
})();
node.text = "query SearchResultsQuery(\n  $after: String\n  $authors: [Int]\n  $before: String\n  $categories: [Int]\n  $first: Int\n  $last: Int\n  $q: String\n  $references: [Int]\n  $sort: String\n  $titleOnly: Boolean\n) {\n  search(authors: $authors, categories: $categories, q: $q, references: $references, sort: $sort, titleOnly: $titleOnly) {\n    searchResults(after: $after, before: $before, first: $first, last: $last) {\n      totalCount\n      edges {\n        node {\n          id\n          pk\n          name\n          preview\n          hasAttachments\n          bloc {\n            name\n            id\n          }\n          isHomeBloc\n          category {\n            name\n            id\n          }\n          effectiveDate\n          legacyEffectiveDate\n          revisionDate\n          approvalDate\n          restricted\n        }\n      }\n    }\n    guestAccessToken\n  }\n}\n";
(node/*: any*/).hash = '3b77e5d58c66686320a13336967ac9c1';
module.exports = node;
